
import paymentApi from '@/api/payment';
import { PAYMENT_METHOD_ID } from "@/constant/payment";

export default {
    data() {
        return {
            isLoadingPolicy: false,
            listRechargePolicy: [],
        }
    },
    computed: {
        listRechargePolicyFiltered() {
            return this.listRechargePolicy?.filter(x => x.percent > 0);
        }
    },
    mounted(){
        this.getPromotionByAmount();
    },
    methods: {
        async getPromotionByAmount() {
            this.isLoadingPolicy = true;
            try {
                const res = await paymentApi.promotionView(PAYMENT_METHOD_ID.ONEPAY);
                console.log('Promotion by amount: ', res);
                this.listRechargePolicy = res?.data || [];
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoadingPolicy = false;
            }
        }
    }
}